// extracted by mini-css-extract-plugin
export var infoRow = "_ul-2";
export var labelContainer = "_ul-0";
export var rightInfo = "_ul-1";